module.exports = __webpack_public_path__ + "img/PM_A01_front_el.907e8755.png";